import(/* webpackMode: "eager" */ "/Users/salasardeveloper/Documents/ashlok_web/ashlok_seo/src/app/ashlok-franklyn-penta/page.js");
